<template>
    <div id="stock_modal_daily" class="ui middle aligned center aligned grid" v-if="showModal">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <div class="ui text menu">
                    <div class="item">
                        <h3 class="ui header">{{ center.name }} 입출고 내역 ({{ partner.name }})</h3>
                    </div>
                    <div class="right menu">
                        <div class="item">
                            <select class="ui simple dropdown" v-model="selectedDate">
                                <option :value="date" v-for="date in Object.keys(orders)" :key="date"> {{ date }} </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div id="body" class="ui segment" v-if="orders[selectedDate]">
                <table class="ui selectable celled compact table">
                    <thead>
                        <tr>
                            <th colspan="3">입고</th>
                        </tr>
                        <tr>
                            <th class="collapsing">#</th>
                            <th>상품명</th>
                            <th class="right collapsing">수량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in getProducts(constant.STOCK_ADD)" :key="p.name + '입고'">
                            <td class="collapsing">{{ index+1 }}</td>
                            <td>{{ p.name }}</td>
                            <td class="right collapsing">{{ p.count }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="ui selectable celled compact table">
                    <thead>
                        <tr>
                            <th colspan="3">출고</th>
                        </tr>
                        <tr>
                            <th class="collapsing">#</th>
                            <th>상품명</th>
                            <th class="right collapsing">수량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in getProducts(constant.STOCK_REMOVE)" :key="p.name + '출고'">
                            <td class="collapsing">{{ index+1 }}</td>
                            <td>{{ p.name }}</td>
                            <td class="right collapsing">{{ p.count }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui text menu">
                    <div class="right menu">
                        <div class="item">
                            <div class="ui small button" @click="close">닫기</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0,
            center: 0,
            partner: 0,
            orders: 0,
            selectedDate: 0,
        }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("openStockDaliyLog", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("openStockDaliyLog");
    },
    methods: {
        open(partner, center) {
            this.$event.call("openLoading");
            this.$api.getAllStockOrders({ _partner: partner._id, _center: center._id }, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.showModal = true;
                    this.center = center;
                    this.partner = partner;
                    this.orders = {};
                    this.selectedDate = "";
                    for (const order of resData.stockOrders) {
                        if (order.confirmedAt) {
                            const confirmedAt = new Date(order.confirmedAt);
                            const type = order.type;
                            const date = confirmedAt.getFullYear() + "/" + (confirmedAt.getMonth() + 1) + "/" + confirmedAt.getDate();

                            if (!this.selectedDate) this.selectedDate = date;
                            if (!this.orders[date]) this.orders[date] = {};
                            for (const p of order.products) {
                                if (!this.orders[date][type]) this.orders[date][type] = {};
                                if (!this.orders[date][type][p.name]) this.orders[date][type][p.name] = { name: "", count: 0, };
                                this.orders[date][type][p.name].name = p.name;
                                this.orders[date][type][p.name].count += p.count;
                            }
                        }
                    }
                }
            });
        },
        close() {
            this.showModal = false;
        },
        getProducts(type) {
            const array = [];
            const products = this.orders[this.selectedDate][type];
            if (products) {
                for (const key of Object.keys(products)) {
                    array.push(products[key]);
                }
            }
            array.sort((a, b) => a.name > b.name ? 1 : -1);
            return array;
        },
    },
    computed: {
        constant: function() { return this.$store.getters.constant; },
    },
}
</script>

<style>

#stock_modal_daily {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#stock_modal_daily .column {
    max-width: 600px;
}

#stock_modal_daily #header {
    padding: 20px 30px;
}

#stock_modal_daily #header .menu {
    margin: 0;
    padding: 0;
}

#stock_modal_daily #header .ui.form {
    margin: 0;
    padding: 0;
}

#stock_modal_daily #body {
    padding: 30px;
    font-size: 13px;
}

#stock_modal_daily #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#stock_modal_daily #footer .ui.menu {
    margin: 0;
}

#stock_modal_daily .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/StockModal_DailyLog.vue